import React from 'react'

const NumberField = ({ name, label, step, value, errors, onChange }) => (
  <div className="form-group">
    {label ? <label htmlFor={name}>{label}</label> : null}
    <input
      className={errors ? 'form-control is-invalid' : 'form-control'}
      type="number"
      step={step}
      name={name}
      id={name}
      value={value}
      onChange={onChange}
    />
    {errors ? <small className="text-danger">{errors[0]}</small> : null}
  </div>
)

export default NumberField
